import CollectProcurment from './CollectProcurmentAgency';

export default CollectProcurment;




// WEBPACK FOOTER //
// ./src/pages/Registration/subComponents/CollectProcurmentAgency/index.jsx